import { Card, CardBody } from "@datapay-by-datacom/design-system";
import type { OverviewResponse } from "../../types";
import { formatNumber } from "../../utils/formatters";
import styles from "./OverviewCards.module.css";

interface KpiItemProps {
  label: string;
  value: number;
  accent?: string;
}

function KpiItem({ label, value, accent }: KpiItemProps) {
  return (
    <Card>
      <CardBody>
        <div className={styles.kpiItem}>
          <span className={styles.kpiLabel}>{label}</span>
          <span className={styles.kpiValue} style={accent ? { color: accent } : undefined}>
            {formatNumber(value)}
          </span>
        </div>
      </CardBody>
    </Card>
  );
}

export interface OverviewCardsProps {
  data: OverviewResponse;
}

export function OverviewCards({ data }: OverviewCardsProps) {
  const health = data.document_health;

  return (
    <div className={styles.container}>
      <div className={styles.kpiGrid}>
        <KpiItem label="Workspaces" value={data.total_workspaces} />
        <KpiItem label="Threads" value={data.total_threads} />
        <KpiItem label="Organisations" value={data.total_orgs} />
        <KpiItem label="Active Users" value={data.active_users} accent="#6366f1" />
        <KpiItem label="Monthly Recurring Users" value={data.mru} accent="#8b5cf6" />
        <KpiItem label="Monthly Recurring Orgs" value={data.mro} accent="#8b5cf6" />
        {data.total_mcp_interactions != null && (
          <KpiItem label="MCP Interactions" value={data.total_mcp_interactions} accent="#14b8a6" />
        )}
        {data.mcp_active_developers != null && (
          <KpiItem label="MCP Developers" value={data.mcp_active_developers} accent="#14b8a6" />
        )}
      </div>

      <div className={styles.healthRow}>
        <span className={styles.healthLabel}>Document Health</span>
        <div className={styles.healthItems}>
          <span className={styles.healthBadge} data-status="total">
            {formatNumber(health.total_documents)} total
          </span>
          <span className={styles.healthBadge} data-status="completed">
            {formatNumber(health.completed)} completed
          </span>
          <span className={styles.healthBadge} data-status="pending">
            {formatNumber(health.pending)} pending
          </span>
          <span className={styles.healthBadge} data-status="failed">
            {formatNumber(health.failed)} failed
          </span>
        </div>
      </div>
    </div>
  );
}
